//Include Both Helper File with needed methods

import {
  
  getFinanceLedgerData,
    
} from "../../../helpers/fakebackend_helper";



import { createAsyncThunk } from "@reduxjs/toolkit";


export const home_finance_ledgerThunk = createAsyncThunk("home_finance_ledgerThunk", async ({ params, token }, { rejectWithValue } ) => {
  try {
    const response = await getFinanceLedgerData( params, token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










